var map = {
	".": 35,
	"./": 35,
	"./GraphQLLanguageService": 103,
	"./GraphQLLanguageService.js": 103,
	"./GraphQLLanguageService.js.flow": 404,
	"./autocompleteUtils": 67,
	"./autocompleteUtils.js": 67,
	"./autocompleteUtils.js.flow": 405,
	"./getAutocompleteSuggestions": 68,
	"./getAutocompleteSuggestions.js": 68,
	"./getAutocompleteSuggestions.js.flow": 406,
	"./getDefinition": 69,
	"./getDefinition.js": 69,
	"./getDefinition.js.flow": 407,
	"./getDiagnostics": 71,
	"./getDiagnostics.js": 71,
	"./getDiagnostics.js.flow": 408,
	"./getOutline": 102,
	"./getOutline.js": 102,
	"./getOutline.js.flow": 409,
	"./index": 35,
	"./index.js": 35,
	"./index.js.flow": 410
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-language-service-interface/dist ^.*$
// module id = 191
// module chunks = 0 1